/** Random identifiers built on Web Crypto, which both the Worker and the browser provide. */

export function randomBytesHex(length: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

/** Cryptographically random, unpadded base64url string of `length` random bytes. */
export function randomBase64Url(length = 32): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

/** Uniform-enough selection for short human codes; alphabets shorter than 256 bias slightly. */
export function randomFromAlphabet(alphabet: string, length: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return [...bytes].map((byte) => alphabet[byte % alphabet.length]).join('');
}
